module.exports = __webpack_public_path__ + "img/7e4a13754b0f8980a74dc005a35673e.9818b72c.png";